import { SlickDataView } from "@slickgrid-universal/common";

const originalMapRowsToIds = SlickDataView.prototype.mapRowsToIds;

SlickDataView.prototype.mapRowsToIds = function (rowArray: number[]) {
  const rows = (this as unknown as { rows?: unknown[] }).rows;
  return originalMapRowsToIds.call(
    this,
    (rowArray || []).filter((row) => rows?.[row] != null),
  );
};
